import { useTranslation } from 'react-i18next'

interface LoadingStateProps {
  labelKey?: string
  compact?: boolean
}

export function LoadingState({
  labelKey = 'common.loading',
  compact = false,
}: LoadingStateProps) {
  const { t } = useTranslation()
  return (
    <div
      role="status"
      aria-live="polite"
      className={
        compact
          ? 'inline-flex items-center gap-3 text-sm text-muted'
          : 'flex min-h-48 flex-col items-center justify-center gap-4 p-6 text-muted'
      }
    >
      <span className="spinner" aria-hidden="true" />
      <span>{t(labelKey)}</span>
    </div>
  )
}

export function FullPageLoader() {
  return (
    <main id="main-content" className="grid min-h-dvh place-items-center bg-paper p-6">
      <LoadingState labelKey="common.loadingScreen" />
    </main>
  )
}
